import { Chart } from 'chart.js';

/*
 * Global Chart.js defaults so every chart (results distribution, loudness,
 * sentiment, speaker time) uses the app's typeface instead of Chart.js's
 * built-in Helvetica. Imported once from App.js — defaults are a singleton
 * and apply to every chart created afterwards.
 */
Chart.defaults.font.family = "'Figtree', ui-sans-serif, system-ui, sans-serif";
Chart.defaults.font.size = 12;
// Mid-tone that stays legible on both the light and dark card surfaces.
Chart.defaults.color = '#8b8797';
